import React from 'react';
import { Icon } from 'antd';
import { Link } from 'react-router';
import TableHelper from 'helpers/Table';
import moment from 'moment';
import _ from 'lodash';
import Utils from 'utils/utils';
import { formatPvCode, formatNumber } from 'utils/formatting';

export default {
  PVCOLUMNS: [
    {
      ...TableHelper.datetimeColumn('Payment\nDate', 'approvedDate'),
      sorter: true,
    },
    {
      ...TableHelper.defaultColumn('PV No.', 'pvCode'),
      render: (value, record) => {
        return formatPvCode(record);
      },
      renderExcel: (value, record) => formatPvCode(record),
      sorter: true,
    },
    {
      ...TableHelper.defaultColumn('Withdrawal\nCode', 'code'),
      render: (value, record) => (
        <div>
          <Link to={`/withdraw/${record._id}`}>{<span>{Utils.FormatNumberLength(value, 6)} </span>}</Link>
          {record.remark && <Icon type="pushpin" />}
        </div>
      ),
    },
    {
      ...TableHelper.defaultColumn('Teacher\nName', 'teacher.displayName'),
      render: (value, record) => <Link to={`/teacher/${_.get(record, 'teacher._id')}`}>{`${_.get(record, 'teacher.name.first')} ${_.get(record, 'teacher.name.last')}`}</Link>,
      renderExcel: (value, record) => `${_.get(record, 'teacher.name.first')} ${_.get(record, 'teacher.name.last')}`,
    },
    {
      ...TableHelper.priceColumn("Teacher's\nRev", 'revenue'),
    },
    {
      ...TableHelper.priceColumn('Net\nCom', 'serviceFee'),
      render: (value, record) => formatNumber(value, '0,0.00'),
      renderExcel: (value, record) => formatNumber(value, '0.00'),
    },
    {
      ...TableHelper.priceColumn('Proc.\nFee', 'cardFee'),
    },
    {
      ...TableHelper.priceColumn('Payout', 'withdrawAmount'),
    },
  ],
  RVCOLUMNS: [
    {
      ...TableHelper.dateColumn('Receipt\nDate', 'createdAt'),
      render: (value, record) => {
        if (record.paymentMethod === 'transfer') {
          if (!_.get(record, 'paymentDetail.dateTime')) {
            return '';
          }

          return <div>{moment(_.get(record, 'paymentDetail.dateTime')).format('DD/MM/YYYY HH:mm')}</div>;
        }
        return moment(value).format('DD/MM/YYYY HH:mm');
      },
      renderExcel: (value, record) => {
        if (record.paymentMethod === 'transfer') {
          if (!_.get(record, 'paymentDetail.dateTime')) {
            return '';
          }
          return moment(_.get(record, 'paymentDetail.dateTime')).format('DD/MM/YYYY HH:mm');
        }
        return moment(value).format('DD/MM/YYYY HH:mm');
      },
      sorter: true,
    },
    {
      ...TableHelper.defaultColumn('Order\nCode', 'code'),
      render: (value, record) => {
        return (
          <div>
            <Link to={`/order/${record._id}`}>{value} </Link>
            {record.remark && <Icon type="pushpin" />}
          </div>
        );
      },
    },
    {
      ...TableHelper.dateColumn('Sche.\nDate', 'schedule.start'),
    },
    {
      ...TableHelper.dateColumn('Student', 'student.displayName'),
      render: (value, record) => <Link to={`/student/${_.get(record, 'student._id')}`}>{`${_.get(record, 'student.name.first')} ${_.get(record, 'student.name.last')}`}</Link>,
      renderExcel: (value, record) => `${_.get(record, 'student.name.first')} ${_.get(record, 'student.name.last')}`,
    },
    {
      ...TableHelper.priceColumn("Teacher's\nRev", 'organicPrice'),
    },
    {
      ...TableHelper.priceColumn('Proc.\nFee', 'cardFee'),
    },
    {
      ...TableHelper.integerColumn('T-Points', 'points'),
    },
    {
      ...TableHelper.priceColumn('Promo\nDisc', 'promocodeDiscountAmount'),
      render: (value, record) => {
        if (value === 'Total') return value;
        return (
          <div>
            <div>{formatNumber(value, '0,0.00')}</div>
            {record.promocode && <div>[{record.promocode}]</div>}
          </div>
        );
      },
    },
    {
      ...TableHelper.priceColumn('Amount\nDue', 'paidPrice'),
    },
    {
      ...TableHelper.priceColumn('Amount\nPaid', 'price'),
      render: (value, record) => {
        let money = record.paidPrice;
        if (_.get(record, 'paymentDetail.money')) {
          money = _.get(record, 'paymentDetail.money');
        }
        return formatNumber(money, '0,0.00');
      },
      renderExcel: (value, record) => {
        let money = record.paidPrice;
        if (_.get(record, 'paymentDetail.money')) {
          money = _.get(record, 'paymentDetail.money');
        }
        return formatNumber(money, '0,0.00');
      },
    },

    {
      ...TableHelper.integerColumn('%Com\nDisc', 'schedule.feeDiscount'),
    },
    {
      ...TableHelper.priceColumn('Net\nCom', 'serviceFee'),
    },
    {
      ...TableHelper.priceColumn('Net\nCom', 'serviceFee'),
    },
    {
      ...TableHelper.defaultColumn('Promo\nCode', 'promocode'),
    },
  ],
};
